import { useEffect, useState } from 'react';
import { Table, Loader, Alert } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import { PageHeader, EmptyState } from '@/components';

// Secrets and hashes never render, even if a model returns them.
const HIDDEN = ['password', 'token_hash', 'serial_hmac'];

/**
 * Generic read-only list page for a registry model (sidebar group "Data") —
 * composed entirely from twreact-ui. Table is responsive by design (mobile
 * cards < 768px). Models that need real screens get one in merchant/routes.jsx.
 */
export default function CrudPage({ model, title }) {
  const { fetchApi } = useAppApi();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let on = true;
    setLoading(true);
    setErr('');
    fetchApi('crud', { model, action: 'list', limit: 50 })
      .then((res) => {
        if (!on) return;
        setRows(Array.isArray(res) ? res : (res && res.data) || []);
      })
      .catch((ex) => on && setErr((ex.response && ex.response.data && ex.response.data.error) || ex.message))
      .finally(() => on && setLoading(false));
    return () => { on = false; };
  }, [model]); // eslint-disable-line react-hooks/exhaustive-deps

  const columns = rows[0]
    ? Object.keys(rows[0]).filter((k) => !HIDDEN.includes(k) && typeof rows[0][k] !== 'object').map((k) => ({ key: k, label: k.replace(/_/g, ' ') }))
    : [];

  return (
    <div className="space-y-4">
      <PageHeader title={title || model} subtitle="Raw records (read-only)." />
      {err ? <Alert variant="error" title="Could not load">{err}</Alert> : null}
      {loading ? (
        <Loader text="Loading…" />
      ) : rows.length ? (
        <Table data={rows.map((r) => Object.fromEntries(Object.entries(r).filter(([k]) => !HIDDEN.includes(k))))} columns={columns} pagination globalSearch showSerial={false} withAction={false} />
      ) : !err ? (
        <EmptyState title={`No ${title || model} records`} />
      ) : null}
    </div>
  );
}
